import { Calendar as ReactCalendar } from "react-calendar";
import "./styles.css";
import { format } from "date-fns";

export const Calendar = ({
    onChange,
    value,
    tileDisabled,
    selectRange = false,
    tileClassName,
    onActiveStartDateChange,
}) => {
    return (
        <ReactCalendar
            onChange={onChange}
            value={value}
            minDate={new Date()}
            showNeighboringMonth={false}
            minDetail="year"
            formatShortWeekday={(locale, date) => format(date, "EEEEE")}
            tileDisabled={tileDisabled}
            selectRange={selectRange}
            tileClassName={tileClassName}
            onActiveStartDateChange={onActiveStartDateChange}
        />
    );
};
